<template>
  <PrizeBanner
    :visible-jackpot="jackpot"
    v-bind="{ ariaLabel, enabled, headline }"
    @click="isModalVisible = true"
  />

  <EditorPrizeModalContent
    v-if="config && !error"
    hidden
    show-title
    v-bind="{ config, lotteryId }"
  />
</template>

<script lang="ts" setup>
import {
  JackpotType,
  type LotteryId,
} from '#api/shared/@types/generated/backend/graphql-schema-types'

import type { Config } from '../@types/editor'

import EditorPrizeModal from './PrizeModal.vue'

type Props = {
  config: Maybe<Config>
  jackpot?: Money
  lotteryId: LotteryId
}

const { config, jackpot, lotteryId } = defineProps<Props>()

const { formatPrizeMoney } = usePrizeMoneyFormatter()
const { t } = useI18n()
const { registerModal } = useModal()

const isModalVisible = ref(false)

const enabled = computed(() => !!config)

const error = computed(() => !hasPrizeTiers(config))

const headline = computed(() =>
  config?.jackpotType === JackpotType.Fixed
    ? t('lottery.teaser.headline.fixed')
    : t('lottery.teaser.headline'),
)

const ariaLabel = computed(() =>
  t('lottery.prizebanner.arialabel', {
    headline: headline.value,
    prize: jackpot ? formatPrizeMoney(jackpot) : t('pricebanner.labels.jackpotmissing'),
  }),
)

registerModal({
  component: EditorPrizeModal,
  onClose: () => {
    isModalVisible.value = false
  },
  props: () =>
    config ? { config, error: error.value, headline: headline.value, jackpot, lotteryId } : null,
  stack: true,
  when: () => isModalVisible.value,
})
</script>
